/* eslint-disable import/prefer-default-export */

import { createEnum } from '../enum';

export const KEY = createEnum({
    TAB: [9, 'Tab'],
    ENTER: [13, 'Enter'],
    ESC: [27, 'Escape', 'Esc'],
    SPACE: [32, ' '],
    BACKSPACE: [8, 'Backspace'],
    END: [35, 'End'],
    HOME: [36, 'Home'],
    DELETE: [46, 'Delete'],
    UP: [38, 'ArrowUp'],
    DOWN: [40, 'ArrowDown'],
    LEFT: [37, 'ArrowLeft'],
    RIGHT: [39, 'ArrowRight'],
    SHIFT: [16, 'ShiftLeft'], // todo shift right
});
